import { render, staticRenderFns } from "./OrganizationLibrary.vue?vue&type=template&id=67b3009a&"
import script from "./OrganizationLibrary.vue?vue&type=script&lang=js&"
export * from "./OrganizationLibrary.vue?vue&type=script&lang=js&"
import style0 from "./OrganizationLibrary.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/__w/ddv-home/ddv-home/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('67b3009a')) {
      api.createRecord('67b3009a', component.options)
    } else {
      api.reload('67b3009a', component.options)
    }
    module.hot.accept("./OrganizationLibrary.vue?vue&type=template&id=67b3009a&", function () {
      api.rerender('67b3009a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ddv-home/OrganizationLibrary.vue"
export default component.exports